import { render, staticRenderFns } from "./numberInput.vue?vue&type=template&id=2e4dc3e3&scoped=true&"
import script from "./numberInput.vue?vue&type=script&lang=js&"
export * from "./numberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4dc3e3",
  null
  
)

export default component.exports